<div class="markdown-header">
    {{ activePageTitleLabelPath | labelsProvider }}
</div>

<div *ngIf="showNoData && (isLoading | async) === false">
    <app-no-data></app-no-data>
</div>
<div *ngIf="isLoading | async" class="spinner">
    <mat-progress-spinner color="primary" mode="indeterminate"> </mat-progress-spinner>
</div>
<markdown class="markdown" [data]="changelogContent"></markdown>
